import React from 'react';
import PropTypes from 'prop-types';

function TitleBar({ name }) {
    return (
        <section className="is-title-bar">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                <a href={'https://disease.scnu.ac.kr/'}>
                    <ul>
                        <div></div>
                    <span className="box"><li>{name}</li></span>
                    </ul>
                </a>
            </div>
        </section>
    );
}

TitleBar.propTypes = {
    name: PropTypes.string.isRequired // 타입 지정 및 필수 여부 설정
};

export default TitleBar;